var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7E8A93",
  fillRule: "evenodd",
  d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h12a1.5 1.5 0 0 1 0 3h-12A1.5 1.5 0 0 1 0 1.5Zm5 5.769a1.5 1.5 0 0 1 1.5-1.5h7a1.5 1.5 0 0 1 0 3h-7a1.5 1.5 0 0 1-1.5-1.5Zm-3.5 4.27a1.5 1.5 0 1 0 0 3h12a1.5 1.5 0 0 0 0-3h-12Z",
  clipRule: "evenodd"
})));
export default SvgMobileFilter;